export let quoteData = [
  {
    quote:
      "What she doin coming back here in dem overhalls? Can't she find no dress to put on?  —Where's dat blue satin dress she left here in? —Where all dat money her husband took and died and left her?",
    author: "Zora Neale Hurston",
    title: "Their Eyes Were Watching God",
    pages: 2,
    originalPublicationDate: 1937,
    originalPublisher: "J.B. Lippincott, Inc.",
    publisher: "Harpers",
    currentCutation: 2006,
    pseudonym: "",
  },
  {
    quote: "She was never tired of living over these two years.",
    author: "Elizabeth Stuart Phelps",
    title: "The Tenth of January",
    pages: 315,
    originalPublicationDate: 1868,
    originalPublisher: "The Atlantic Monthly",
    publisher: "Feminist Press",
    currentCutation: 1983,
    pseudonym: "",
  },
  {
    quote:
      "It was impossible for her daughter to forget that a woman of intellectual power could be the most successful of mothers.",
    author: "Elizabeth Stuart Phelps",
    title: "Chapters from a Life",
    pages: 12,
    originalPublicationDate: 1896,
    originalPublisher: "Houghton Miflin",
    publisher: "Houghton and Co.",
    currentCutation: 1897,
    pseudonym: "",
  },
  {
    quote:
      "She lived one of those rich and pitious lives such as only gifted women knew; torn by the civil war of the dual nature which can be given to women only.",
    author: "Elizabeth Stuart Phelps",
    title: "Chapters from a Life",
    pages: 12,
    originalPublicationDate: 1896,
    originalPublisher: "Houghton Miflin",
    publisher: "Houghton and Co.",
    currentCutation: 1897,
    pseudonym: "",
  },
  {
    quote:
      "She was reputed to be dumb, but none could speak with certainty of the fact.",
    author: "E.D.E.N. Southworth",
    title: "The Hidden Hand or, Capitola the Madcap",
    pages: 141,
    originalPublicationDate: 1859,
    originalPublisher: "The New York Ledger",
    publisher: "Rutgers University Press",
    currentCutation: 2010,
    pseudonym: "",
  },
  {
    quote:
      "[I]ndeed, the ignorant and superstitious believed her to possess the 'evil eye,' and to be gifted with 'second sight.'",
    author: "E.D.E.N. Southworth",
    title: "The Hidden Hand or, Capitola the Madcap",
    pages: 141,
    originalPublicationDate: 1859,
    originalPublisher: "The New York Ledger",
    publisher: "Rutgers University Press",
    currentCutation: 2010,
    pseudonym: "",
  },
  {
    quote:
      "Very lonely and desolate the mother felt as she stood weeping by the window, . . .",
    author: "E.D.E.N. Southworth",
    title: "The Hidden Hand or, Capitola the Madcap",
    pages: 172,
    originalPublicationDate: 1859,
    originalPublisher: "The New York Ledger",
    publisher: "Rutgers University Press",
    currentCutation: 2010,
    pseudonym: "",
  },
  {
    quote:
      "When she was alone she looked mechanically at the back of her hand which he had kissed so warmly.",
    author: "Kate Chopin",
    title: "The Awakening",
    pages: 77,
    originalPublicationDate: 1899,
    originalPublisher: "Herbert S. Stone",
    publisher: "Norton & Company",
    currentCutation: 1976,
    pseudonym: "",
  },
  {
    quote:
      "She felt somewhat like a woman who in a moment of passion is betrayed into an act of infedelity, and realizes the significance of the act without being wholly awakened from its glamour.",
    author: "Kate Chopin",
    title: "The Awakening",
    pages: 77,
    originalPublicationDate: 1899,
    originalPublisher: "Herbert S. Stone",
    publisher: "Norton & Company",
    currentCutation: 1976,
    pseudonym: "",
  },
  {
    quote:
      "For the first time in many years the tired woman rested, body and heart and brain.",
    author: "Isabella Macdonald Alden",
    title: "The King's Daughter",
    pages: 13,
    originalPublicationDate: 1873,
    originalPublisher: "D. Lothrop & Co.",
    publisher: "Creation House",
    currentCutation: 1992,
    pseudonym: "",
  },
  {
    quote:
      "Suddenly this girl, so practical, so humorous, so clever in every-day life, covered her face with her hands and sobbed like a child. Two roads of life had lain before her and she had chosen the hardest.",
    author: "Edith Maude Eaton",
    title: "The Inferior Woman",
    pages: 46,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "She neither frowned nor smiled when the time came that she was obliged to move; she simply moved, with as unconverned and indifferent a face as she had worn all the time.",
    author: "Isabella Macdonald Alden",
    title: "Four Girls at Chautauqua",
    pages: 38,
    originalPublicationDate: 1876,
    originalPublisher: "D. Lothrop & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Pansy",
  },
  {
    quote: "In this country, she is most happy who has no child,",
    author: "Edith Maude Eaton",
    title: "The Wisdom of the New",
    pages: 60,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "[T]he young daughter of Lew Wing, is as bold and free in her ways as are the white women, and her name is on all the men's tongues. What prudent man of our race would take her as a wife?",
    author: "Edith Maude Eaton",
    title: "The Wisdom of the New",
    pages: 60,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "The sing-song voices of girls whom respectable merchants' wives shudder to name, were calling to one another from high balconies up shadowy alleys.",
    author: "Edith Maude Eaton",
    title: "The Wisdom of the New",
    pages: 62,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "Still, it is not always pleasant to be a woman, - and yet think; a woman whose reason has been mistakenly developed at the expense of her capacity to enjoy being a woman, and who is forced at the same time to encounter the laws of Nature, and pay at the same time, the penalty of being a woman, and the penalty of knowledge.",
    author: "Mildrid Aldrich",
    title: "Told in a French Garden, August 1914",
    pages: 148,
    originalPublicationDate: 1916,
    originalPublisher: "Small, Maynard & Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "She can be happy who takes all and gives nothing.",
    author: "Edith Maude Eaton",
    title: "The Wisdom of the New",
    pages: 66,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "Women have washed and baked, scrubbed, cried and prayed themselves into their graves for thousands of years, and no person has written a book advising them not to work too hard;",
    author: "Olive San Louie Anderson",
    title: "An American Girl, and Her Four Years in a Boys' College",
    pages: 98,
    originalPublicationDate: 1878,
    originalPublisher: "D. Appleton and Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "SOLA",
  },
  {
    quote:
      "[T]hree girls lavishly dressed in colored silks, with their black hair plastered back from their faces and heavily bejewelled behind, chirped and chattered in a gilded balcony above them like birds in a cage.",
    author: "Edith Maude Eaton",
    title: "The Wisdom of the New",
    pages: 72,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "The woman shuddered and the low moans became heartwrending cries and sobs.",
    author: "Edith Maude Eaton",
    title: "The Gift of Little Me",
    pages: 99,
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      'She had burnt incence to "Mother" and besought the aid of the goddess of children; but her prayers would not avail,',
    author: "Edith Maude Eaton",
    title: "The Gift of Little Me",
    pages: "99-100",
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "Their grateful appreciation of the smallest service: their undemonstrative but faithful affection had been as a balm to the heart wounded by the indifference and bruised by the ingratitude of the those to whom she had devoted her youth, her strength, and her abilities",
    author: "Edith Maude Eaton",
    title: "The Gift of Little Me",
    pages: "103-104",
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "I did not admire clever business women, as I had usually found them, and so had other girls of my acquaintence, not nearly so kind-hearted, generous, and helpful as the humble drudges of the world - the ordinary working woman.",
    author: "Edith Maude Eaton",
    title: "The Story of One White Woman who Married a Chinese",
    pages: "112-113",
    originalPublicationDate: 1912,
    originalPublisher: "McClurg & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Sui Sin Far",
  },
  {
    quote:
      "We regarded her with something of awe, and I have wondered, in later days, what strange and eldritch beings walked with her",
    author: "Harriet Bates",
    title: "Old Salem",
    pages: 79,
    originalPublicationDate: 1893,
    originalPublisher: "Houghton Miflin",
    publisher: "",
    currentCutation: "",
    pseudonym: "Eleanor Putnam",
  },
  {
    quote:
      "I loved her because she gave up so much of herself. But I knew I could never never be like that.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 19,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "If only women could bring into their homes this self-sacrificing attitude toward life! Isn't just as satisfying to the soul to feel you have scrubbed a floor faithfully as to be mistress of the house?",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 77,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "A woman who deals in poison cannot be trusted, whatever she says.",
    author: "Mary Ellen Bamford",
    title: "Father Lambert's Family: A Story of Old-Time France",
    pages: 63,
    originalPublicationDate: 1888,
    originalPublisher: "Phillips & Hunt",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "With all her beauty treatments, her Paris gowns, she can't keep her husband's love.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 103,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "Her face had beamed with the pleasure of doing good.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 104,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Fond as we are of our girls, we must not let our affection for them cloud our vision as to what is wisest and best for their future welfare.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 106,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "The song without words of the poor. Her leaning forward and pulling back at the tub was as soothing as rocking a child to sleep in the dust.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 168,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "It had seemed to me nothing on earth could be as terrible as to grow so old and bent. And yet she could smile like that.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 170,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "That frail, bent old thing making of her nothing a feast of plenty, feeding with it little hungry mouths that never had enough.",
    author: "Anzia Yezierska",
    title: "Arrogant Beggar",
    pages: 225,
    originalPublicationDate: 1927,
    originalPublisher: "Double Day",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "In the divine unconsciousness of innocent childhood she comforted the pure and the guilty woman alike.",
    author: "Lilian Lida Bell",
    title: "A Little Sister to the Wilderness",
    pages: 200,
    originalPublicationDate: 1895,
    originalPublisher: "Stone & Kimball",
    publisher: "",
    currentCutation: "",
    pseudonym: "Mrs. Arthur Hoyte Bogue",
  },
  {
    quote:
      "At such times she would plunge into a round of reckless gayety and try to forget for the time being her unsatisfied longing and love",
    author: "Winnifred Eaton",
    title: "Miss Numè of Japan: A Japanese-American Romance",
    pages: 41,
    originalPublicationDate: 1899,
    originalPublisher: "Rand, McNally & Co.",
    publisher: "The Johns Hopkins University Press",
    currentCutation: 1999,
    pseudonym: "Onoto Watanna",
  },
  {
    quote:
      "Intuitions are given to women, not because they are the weaker sex, but  because they are the mothers of the world, and they are thus given the strongest protection against unseen and unseeable evils",
    author: "Lilian Lida Bell",
    title: "Angela's Quest",
    pages: 135,
    originalPublicationDate: 1910,
    originalPublisher: "Duffield & Co.",
    publisher: "",
    currentCutation: "",
    pseudonym: "Mrs. Arthur Hoyte Bogue",
  },
  {
    quote:
      "A woman with a conscience often makes a burnt-offering of her heart, from pure altruism.",
    author: "Lilian Lida Bell",
    title: "The Under Side of Things",
    pages: 230,
    originalPublicationDate: 1896,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "Mrs. Arthur Hoyte Bogue",
  },
  {
    quote:
      "She was less the alluring woman than the burning exultant spirit, cased in a woman's body and shining through it like a light through a transparent shell.",
    author: "Geraldine Bonner",
    title: "The Book of Evelyn",
    pages: 288,
    originalPublicationDate: 1913,
    originalPublisher: "Bobbs-Merrill",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "About her clung that dim suggestion of polite insolence with which a few women are born and which some acquire with the coming of riches or importance.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 29,
    originalPublicationDate: 1929,
    originalPublisher: "Alfred A. Knopf",
    publisher: "Penguin",
    currentCutation: 2018,
    pseudonym: "",
  },
  {
    quote:
      "She was a woman now - a very young one, it is true, but full of all a woman's witchery and grace",
    author: "Kate Langley Bosher",
    title: "Bobbie",
    pages: 44,
    originalPublicationDate: 1899,
    originalPublisher: "B. F. Johnson",
    publisher: "",
    currentCutation: "",
    pseudonym: "Kate Cairns",
  },
  {
    quote:
      "[H]er erect attitude, her free and lofty tread, and the perfect composure of her countenance, all expressed the courage and dignity of her soul.",
    author: "Catharine Maria Sedgwick",
    title: "Hope Leslie, or, Early Times in the Massachusetts",
    pages: 297,
    originalPublicationDate: 1827,
    originalPublisher: "",
    publisher: "Penguin",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote: "She clutched at her throat like one stifled for want of air.",
    author: "Anzia Yezierska",
    title: "Wings",
    pages: 3,
    originalPublicationDate: 1920,
    originalPublisher: "Houghton Mifflin",
    publisher: "Persea Books",
    currentCutation: 1991,
    pseudonym: "",
  },
  {
    quote:
      "The first five had grown up in an atmospher of holy calm, of awed watchful waiting, of breathless prayer.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 49,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "[H]er children were captives - and her heart was broken. You know the rest",
    author: "Catharine Maria Sedgwick",
    title: "Hope Leslie, or, Early Times in the Massachusetts",
    pages: 55,
    originalPublicationDate: 1827,
    originalPublisher: "",
    publisher: "Penguin",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "Their twenty-five daughters in turn, with a stronger hope, a richer, wider outlook, with the devoted love and care of all the surviving population, grew up as a holy sisterhood, their whole ardent youth looking forward to their great office.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 49,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "A mother, encircled by healthful sporting children, is always a beautiful spectacle",
    author: "Catharine Maria Sedgwick",
    title: "Hope Leslie, or, Early Times in the Massachusetts",
    pages: 63,
    originalPublicationDate: 1827,
    originalPublisher: "",
    publisher: "Penguin",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "Several times during the day, she found herself at the broken mirror, arranging and rearranging her dark mass of unkemp hair with fumbling fingers.",
    author: "Anzia Yezierska",
    title: "Wings",
    pages: 9,
    originalPublicationDate: 1920,
    originalPublisher: "Houghton Mifflin",
    publisher: "Persea Books",
    currentCutation: 1991,
    pseudonym: "",
  },
  {
    quote:
      "Each girl, of course, was reared in full knowledge of her Crowning Office, and they had, even then, very high ideas of the molding powers of the mother, as well as those of education.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 51,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "No, I am accustomed to being on the water; I often row alone. I dont even remember of feeling 'drunk.' What kind of a feeling is it?",
    author: "S. Alice Callahan",
    title: "Wynema: A Child of the Forest",
    pages: 43,
    originalPublicationDate: 1891,
    originalPublisher: "H.J. Smith",
    publisher: "University Nebraska Press",
    currentCutation: 1997,
    pseudonym: "",
  },
  {
    quote:
      "They had no enemies; they themselves were all sister and friends. The land was fair before them, and a great future began to form in their minds.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 51,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "By motherhood they were born and by motherhood they lived--life was, to them, just the long cycle of motherhood.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 51,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "They were sisters, and as they grew, they grew together--not by competition, but by united action.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 51,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "Lying there, with nothing in sight but the leafy branches of the trees high abover her head, through which gleams of the deep blue sky came softly, she felt as if she had left the world, and was floating, Ariel-like, in mid-air.",
    author: "Pauline E. Hopkins",
    title: "Hagar's Daughter: A Story of Southern Caste Prejudice",
    pages: 36,
    originalPublicationDate: "1901-02",
    originalPublisher: "Colored American Magazine",
    publisher: "Oxford University Press",
    currentCutation: 1988,
    pseudonym: "",
  },
  {
    quote:
      "[S]he was beloved--she loved again--and she had rashly dashed away the happiness within her grasp",
    author: "Catharine Maria Sedgwick",
    title: "Hope Leslie, or, Early Times in the Massachusetts",
    pages: 231,
    originalPublicationDate: 1827,
    originalPublisher: "",
    publisher: "Penguin",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "You see, they were Mothers, not in our sense of helpless involuntary fecundity, forced to fill and overfill the land, every land, and then see their children suffer, sin, and die, fighting horribly with one another; but in the sense of Concious Makers of People.",
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 58,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      'Mother-love with them was not a brute passion, a mere "instinct," a wholly personal feeling; it was--a religion.',
    author: "Charlotte Perkins Gilman",
    title: "Herland",
    pages: 58,
    originalPublicationDate: 1915,
    originalPublisher: "Charlotte Perkins Gilman",
    publisher: "Dover",
    currentCutation: 1998,
    pseudonym: "",
  },
  {
    quote:
      "Sometimes girlhood is a mysterious chaos of traits, out of which no one can foretell what sort of cosmos will follow, or whether there will be a cosmos at all or only intelligent chaos to the end. But this girl seemed to carry her future in her face.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 122,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "With her revolutionary, anarchistic completeness, she has renounced the idea of compromise or adaptability as finally as if she had seen and past the end of the world.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 13,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "That is because you are a woman and can't help looking at it from a woman's standpoint.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 98,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She is not like her naughty sister Rachel, who won't do anything but read, and never loves anybody but herself.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 69,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Surely if she had been a good wife, an unselfish and loving wife, he could not have been enticed away.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 152,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She and her children have eggs and buttered rolls for breakfast each morning like millionaires.",
    author: "Anzia Yezierska",
    title: "The Fat of the Land",
    pages: 79,
    originalPublicationDate: 1920,
    originalPublisher: "Houghton Mifflin",
    publisher: "Persea Books",
    currentCutation: 1991,
    pseudonym: "",
  },
  {
    quote:
      "They had pathetic purple shadows under them, which told of sleepless nights with the babies, and there were fine lines around her mouth; but her light-brown hair was a smooth and her dress as plain and neat as ever.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: "124-5",
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Her unselfish zeal never flagged. She flitted from one want to another as naturally as she breathed and with as little consciousness of the process.",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 125,
    originalPublicationDate: 1902,
    originalPublisher: "Harper and Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She worked herself up into such a hysteria, crying, and tearing her hair, and hitting her head with her knuckles, that at last she fell into a faint",
    author: "Anzia Yezierska",
    title: "The Fat of the Land",
    pages: 79,
    originalPublicationDate: 1920,
    originalPublisher: "Houghton Mifflin",
    publisher: "Persea Books",
    currentCutation: 1991,
    pseudonym: "",
  },
  {
    quote:
      "Her year abroad has lengthened into several years, and they have been the most beautiful of her life . . . .",
    author: "Lilian Lida Bell",
    title: "The Love of Affairs of an Old Maid",
    pages: 182,
    originalPublicationDate: 1902,
    originalPublisher: "",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She had come among the barenesss and sordidness of this neighborhood five years ago, robed in crape, and crying with great sobs that seemed to shake the vitality out of her.",
    author: "Alice Dunbar Nelson",
    title: "Little Miss Sophie",
    pages: 141,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "The human element in the room was furnished by a little, wizened yellow woman, who, black-robed, turbaned, and stern, sat before an uncertain table whereon were greasy cards.",
    author: "Alice Dunbar Nelson",
    title: "The Goodness of Saint Rocque",
    pages: 8,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "She was small and wizened and old, with yellow, flabby jaws, a neck like the throat of an alligator, and straight, which hair that stood from her head uncannily stiff.",
    author: "Alice Dunbar Nelson",
    title: "A Carnival Jangle",
    pages: 130,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "Untutored in worldly knowledge, she could not divine the meaning of the pronounced leers and admiration of her physical charms which gleamed in the man's face, but she knew it made her feel creepy, and stoutly refused to go.",
    author: "Alice Dunbar Nelson",
    title: "Sister Josepha",
    pages: 159,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "I was doubtless intuition of the quick, vivacious sort which belonged to her blood that served her.",
    author: "Alice Dunbar Nelson",
    title: "Sister Josepha",
    pages: 159,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "She scarcely kept the flickering life in her pale little body by the unceasing toil of a pair of bony hands, stitiching, stitching, ceaselessly, wearingly, on the bands and pockets of trousers. It was her bread, . . . it was her only hope of life.",
    author: "Alice Dunbar Nelson",
    title: "Little Miss Sophie",
    pages: 139,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "For your Creole girls are proud, and would die rather than let the world see their sorrows.",
    author: "Alice Dunbar Nelson",
    title: "The Goodness of Saint Rocque",
    pages: 13,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "Outside the long sweet march music of many bands floated in as if in mockery, and the flash of rockets and Bengal lights illuminated the dead, white face of the girl troubadour.",
    author: "Alice Dunbar Nelson",
    title: "A Carnival Jangle",
    pages: 134,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "And thus it was that Camile took the white veil at sixteen years. Now that the period of novitiate was over, it was just beginning to dawn upon her that she had made a mistake.",
    author: "Alice Dunbar Nelson",
    title: "Sister Josepha",
    pages: 161,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "There were tears in her eyes, hot blinding ones that would n't drop for pride, but stayed and scalded.",
    author: "Alice Dunbar Nelson",
    title: "Little Miss Sophie",
    pages: 145,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "She would rely on the mercies of the world to help her escape from this torturing life of inertia.",
    author: "Alice Dunbar Nelson",
    title: "Sister Josepha",
    pages: 169,
    originalPublicationDate: 1899,
    originalPublisher: "Dodd, Mead and Company",
    publisher: "McGrath Publishing",
    currentCutation: 1969,
    pseudonym: "",
  },
  {
    quote:
      "If you feel you are right, dear girl, stand for the uplifting of the race and womanhood. Do not shrink from duty.",
    author: "Pauline E. Hopkins",
    title:
      "Contending Forces: A Romance Illustrative of Negro Life North and South",
    pages: 156,
    originalPublicationDate: 1900,
    originalPublisher: "The Colored Co-operative Publishing",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[Y]ou won't be able to keep from loving her; she has the sweetest and saddest face I ever saw. I have read of the woman with a story written on her face, bit I never believed it anything but a fairy tale.",
    author: "Pauline E. Hopkins",
    title:
      "Contending Forces: A Romance Illustrative of Negro Life North and South",
    pages: 89,
    originalPublicationDate: 1900,
    originalPublisher: "The Colored Co-operative Publishing",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "It was thought she might be eclipsed by the younger and more brilliant women students on the strength of their alma mater, but she still held her own by sheer force of will-power and indomitable pluck.",
    author: "Pauline E. Hopkins",
    title:
      "Contending Forces: A Romance Illustrative of Negro Life North and South",
    pages: 148,
    originalPublicationDate: 1900,
    originalPublisher: "The Colored Co-operative Publishing",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Did I understand you to say that the Negro woman in her native state is truly a virtuous woman?",
    author: "Pauline E. Hopkins",
    title:
      "Contending Forces: A Romance Illustrative of Negro Life North and South",
    pages: 148,
    originalPublicationDate: 1900,
    originalPublisher: "The Colored Co-operative Publishing",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "In her hands committees were as wax, and loud murmurings against the tyranny of her rule died down to judicious whispers.",
    author: "Pauline E. Hopkins",
    title:
      "Contending Forces: A Romance Illustrative of Negro Life North and South",
    pages: 147,
    originalPublicationDate: 1900,
    originalPublisher: "The Colored Co-operative Publishing",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Young, beautiful, well-born, and wealthy, surrounded by every luxury money could purchase or a cultivated taste long for, Jewek was supremely wretched.",
    author: "Pauline E. Hopkins",
    title: "Hagar's Daughter: A Story of Southern Caste Prejudice",
    pages: 199,
    originalPublicationDate: "1901-02",
    originalPublisher: "Colored American Magazine",
    publisher: "Oxford University Press",
    currentCutation: 1988,
    pseudonym: "",
  },
  {
    quote:
      "The reading of the will had shown her how dependent she would be upon this man. The thought of him as a guardian made her sick at heart.",
    author: "Pauline E. Hopkins",
    title: "Hagar's Daughter: A Story of Southern Caste Prejudice",
    pages: 204,
    originalPublicationDate: "1901-02",
    originalPublisher: "Colored American Magazine",
    publisher: "Oxford University Press",
    currentCutation: 1988,
    pseudonym: "",
  },
  {
    quote:
      "She might have made us all love her, and help to make her old age cheerful; but now, unless she repents, she will live miserably, and die forsaken, for nobody can love her with such a temper.",
    author: "Fanny Fern",
    title: "Ruth Hall: A Domestic Tale or the Present Time",
    pages: "363-4",
    originalPublicationDate: 1855,
    originalPublisher: "Mason Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "were I a man, it would be so sweet to use my powers to defend the defenseless. It would seem to me so impossible to use that power to echo the faintest rumor adverse to a woman, or to keep cowardly silence in the shrugging, sneering, slanderer's presence, when a bold word of mine for the cause of right, might close his dastard lips.",
    author: "Fanny Fern",
    title: "Ruth Hall: A Domestic Tale or the Present Time",
    pages: 328,
    originalPublicationDate: 1855,
    originalPublisher: "Mason Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "Ruth felt as if wings were growing from her shoulders.",
    author: "Fanny Fern",
    title: "Ruth Hall: A Domestic Tale or the Present Time",
    pages: 331,
    originalPublicationDate: 1855,
    originalPublisher: "Mason Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Ruth's tears fell fast. She knew now how it could be, when every door of hope seemed shut, by those who make long prayers and wrap themselves in morality as with a garment, and cry with closed purses and averted faces, . . .",
    author: "Fanny Fern",
    title: "Ruth Hall: A Domestic Tale or the Present Time",
    pages: 173,
    originalPublicationDate: 1855,
    originalPublisher: "Mason Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[I]f you should feel the need of exercise, don't gad in the streets. Remember there is nothing like a broom and a dust-pan to make the blood circulate.",
    author: "Fanny Fern",
    title: "Ruth Hall: A Domestic Tale or the Present Time",
    pages: 31,
    originalPublicationDate: 1855,
    originalPublisher: "Mason Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "As she spoke of the past she suddenly became made again, and for hours I fought with her.",
    author: "Kate Langley Bosher",
    title: "The House of Happiness",
    pages: 227,
    originalPublicationDate: 1913,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She lost her soul. She went in a factory, but the air made her sick.",
    author: "Kate Langley Bosher",
    title: "People Like That",
    pages: 132,
    originalPublicationDate: 1916,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "She's an odd little thing, all fire and flame.",
    author: "Kate Langley Bosher",
    title: "People Like That",
    pages: 147,
    originalPublicationDate: 1916,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She took her luxuries as the birds of the air take light and sunshine.",
    author: "Kate Langley Bosher",
    title: "People Like That",
    pages: 163,
    originalPublicationDate: 1916,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "For a moment she stood puzzled and helpless. Something she did not understand was troubling, something in which she could not help.",
    author: "Kate Langley Bosher",
    title: "How It Happened",
    pages: 17,
    originalPublicationDate: 1914,
    originalPublisher: "Harper & Brothers",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She clasped her knees loosely with her hands, and the flames danced merrily up and down before her blurred eyes.",
    author: "Kate Langley Bosher",
    title: "Bobbie",
    pages: 74,
    originalPublicationDate: 1899,
    originalPublisher: "B. F. Johnson",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She could weep in the midst of her happiness, hearing that endless prayer.",
    author: "Julia Evelyn Ditto Young",
    title: "The Story of Saville: Told in Numbers",
    pages: 58,
    originalPublicationDate: 1897,
    originalPublisher: "Roycroft Printing Shop",
    publisher: "Roycroft Printing Shop",
    currentCutation: 1900,
    pseudonym: "",
  },
  {
    quote:
      "She had come to believe that the dogs in the street howled as she passed them by, and every glance at her face was a blow, and her every breath was a cry!",
    author: "Julia Evelyn Ditto Young",
    title: "The Story of Saville: Told in Numbers",
    pages: 82,
    originalPublicationDate: 1897,
    originalPublisher: "Roycroft Printing Shop",
    publisher: "Roycroft Printing Shop",
    currentCutation: 1900,
    pseudonym: "",
  },
  {
    quote:
      "She turns away with a sinking heart, but will not give it up so; she may get it of some one yet.",
    author: "Lois Nichols Waisbrooker",
    title: "Mayweed Blossoms",
    pages: 116,
    originalPublicationDate: 1871,
    originalPublisher: "William White",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She had cried bitterly at first because she could not have her own bed; but childhood soon forgets, and now she was sleeping soundly.",
    author: "Lois Nichols Waisbrooker",
    title: "Mayweed Blossoms",
    pages: 258,
    originalPublicationDate: 1871,
    originalPublisher: "William White",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[I]t was pervading her entire being, running along her nerves with a strange thrill, mounting to and bewildering her brain.",
    author: "Lois Nichols Waisbrooker",
    title: "Nothing Like It, Or Steps to the Kingdom",
    pages: 54,
    originalPublicationDate: 1885,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She managed to escape at length, and, reeling from weakness and despair, she had fallen in the street; and it was thus that we found her.",
    author: "Lois Nichols Waisbrooker",
    title: "Nothing Like It, Or Steps to the Kingdom",
    pages: 57,
    originalPublicationDate: 1885,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She is lovely, intelligent, refined; often more so than the one who occupies the place of mistress.",
    author: "Lois Nichols Waisbrooker",
    title: "Nothing Like It, Or Steps to the Kingdom",
    pages: 76,
    originalPublicationDate: 1885,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She seemed to me like a gush of sunshine and song pervading a bed of violets.",
    author: "Lois Nichols Waisbrooker",
    title: "Nothing Like It, Or Steps to the Kingdom",
    pages: 97,
    originalPublicationDate: 1885,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She has access now to those that she could no reach, were she to try to work with such as call themselves Christians.",
    author: "Lois Nichols Waisbrooker",
    title: "Nothing Like It, Or Steps to the Kingdom",
    pages: 109,
    originalPublicationDate: 1885,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She opened her lips as if to question; when her eye caught sight of the plae, still form, and she remained silent.",
    author: "Lois Nichols Waisbrooker",
    title: "Helen Harlow's Vow",
    pages: 76,
    originalPublicationDate: 1887,
    originalPublisher: "William White",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She had spoken calmly and firmly; but her face was pallid to the hue of death, and the light which flashed from her eyes was scorching in its intensity.",
    author: "Lois Nichols Waisbrooker",
    title: "Helen Harlow's Vow",
    pages: 17,
    originalPublicationDate: 1887,
    originalPublisher: "William White",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "She would have been canonized as a saint.",
    author: "Lois Nichols Waisbrooker",
    title: "Perfect Motherhood, Or, Mabel Raymond's Resolve",
    pages: 114,
    originalPublicationDate: 1890,
    originalPublisher: "Murray Hill Publishing Company",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She followed the pathway that was formed by the myriad dust-particles, whirling in dizzy vortices like shifting sands of gold.",
    author: "Mary Ella Waller",
    title: "The Rose-bush of Hildesheim: A Cathedral Story",
    pages: 28,
    originalPublicationDate: 1889,
    originalPublisher: "Estes and Lauriat",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She turned her face upward, and a low cry of delight broke from her.",
    author: "Mary Ella Waller",
    title: "The Rose-bush of Hildesheim: A Cathedral Story",
    pages: 23,
    originalPublicationDate: 1889,
    originalPublisher: "Estes and Lauriat",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "As she cowered there, she felt the train moving more slowly.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 35,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "She struggled to avert her look, but her eyes refused to move and her head seemed to be held in a vice.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 42,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "She felt herself beset with difficulties too evasive to be fought by so direct a temperament.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 29,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote: "The silence frightened her more than any sound.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 32,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote: "She sat up stiffly, staring out at the dawn.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 33,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote: "She found herself the centre of sympathetic eyes.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 38,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "The burning sensation in her throat acted as a counter-irritant, momentarily relieving the dull ache of her nerves.",
    author: "Edith Wharton",
    title: "A Journey",
    pages: 43,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "It was a glorious thing for a girl, she said, wasn't it, to be associated with such a life as that?",
    author: "Edith Wharton",
    title: "The Portait",
    pages: 241,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "She was not stupid; she was not obtuse; one felt that her impassive surface was alive with delicate points of perception...",
    author: "Edith Wharton",
    title: "The Portait",
    pages: 241,
    originalPublicationDate: 1899,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote:
      "She had shown, as a girl, little fondness for society, nor had she seemed to regret it during the year they had spent in the country.",
    author: "Edith Wharton",
    title: "The Touchstone",
    pages: 337,
    originalPublicationDate: 1900,
    originalPublisher: "Charles Scribner's Sons",
    publisher: "Charles Scribner's Sons",
    currentCutation: 1914,
    pseudonym: "",
  },
  {
    quote: "She was chilly, in her white dress, from the night air.",
    author: "Adeline Dutton Train Whitney",
    title: "Faith Gartney's Girlhood",
    pages: 260,
    originalPublicationDate: 1863,
    originalPublisher: "Loring",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She thought she could almost bear anything else, if only this stiff, unseemly crop might length out to waves and ringlets that should toss in the wind like the carefully kempt tresses of children she met in the streets.",
    author: "Adeline Dutton Train Whitney",
    title: "Faith Gartney's Girlhood",
    pages: 30,
    originalPublicationDate: 1863,
    originalPublisher: "Loring",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She came suddenly to herself, however, and darted off, with her face as bright a crimson as her hair was golden...",
    author: "Adeline Dutton Train Whitney",
    title: "Faith Gartney's Girlhood",
    pages: 98,
    originalPublicationDate: 1863,
    originalPublisher: "Loring",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "To a strictly classical eye she was too thin for her height, but of such exact proportions, so flexible and graceful, that the defect was insignificant.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 11,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote: "Ordinarily she was pale, and her large dark eye lacked lustre...",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 11,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "She came in as she would have entered any other drawing-room on any other occasion -- neither bold, nor timid.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 27,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "[W]e are taught by books, by all the talk we hear from old and young, married and single, that marriage is not only the felicity of woman, but that her diginity, her attractiveness, her usefulness depends on it. . . .",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: "29-30",
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "She may prove something very different from the pretty shallowness she seems.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 31,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "There is a principle of spirtual development in her that clouds will but nuture.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 35,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "She is so deeply stamped by nature, that neither time nor custom will wear out the impression.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 35,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote: "[S]he will wish to have lived when she comes to die.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 36,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "She sat with her head inclined downward, in a listening and meditative posture.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 65,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote:
      "She was caught between two allegiances, different, yet the same. Herself. Her race.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 180,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Race! The thing that bound and suffocated her. Whatever steps she took, or if she took none at all, something would be crushed.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 180,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "For the first time she suffered and rebelled because she was unable to disregard the burden of race. It was, she cried silently, enough to suffer as a woman, an individual, on one's own account, without having to suffer for the race as well.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 181,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Was it, perhaps, that she had endured all that woman could endure of tormenting humiliation and fear? Or was it that she lacked the capacity for the acme of suffering?",
    author: "Nella Larsen",
    title: "Passing",
    pages: 199,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "And did too much striving, too much faith in safety and permancence, unfit one for these other things?",
    author: "Nella Larsen",
    title: "Passing",
    pages: 200,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Security. Was it just a word? If not, then was it only by the sacrifice of other things, happiness, love, or some wild ecstacy that she had never known, that it could be obtained?",
    author: "Nella Larsen",
    title: "Passing",
    pages: 200,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She belonged in this land of rising towers. She was an American. She grew from this soil, and she would not be uprooted.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 201,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[S]he was aware that, to her, security was the most important and desired thing in life. Not for any of the others, or for all of them, would she exchange it.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 200,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Strange, that she couldn't now be sure that she had ever truly known love.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 201,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "At this crisis of her life, she was in danger of resigning the control of this element to another in whose hands it would be sure to become a destructive agent.",
    author: "Catharine Maria Sedgwick",
    title: "Married or Single?",
    pages: 137,
    originalPublicationDate: 1857,
    originalPublisher: "Harper",
    publisher: "Univeristy of Nebraska Press",
    currentCutation: 2015,
    pseudonym: "",
  },
  {
    quote: "She seemed unaware of any danger or uncaring.",
    author: "Nella Larsen",
    title: "Passing",
    pages: 209,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[A] calm desperation came over her. She braced herself, physically and mentally",
    author: "Nella Larsen",
    title: "Passing",
    pages: 213,
    originalPublicationDate: 1929,
    originalPublisher: "A. A. Knopf",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[T]he younger girl loved the sudden, mystic hush which seemed to descend on the congregation.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 23,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote: "Death triumphant and mighty had no fears for her.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 25,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[C]onstancy was no virtue in her eyes; she did not possess it herself and she valued it little in others.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 29,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "And again she let herself dwell on the fallaciousness of a social system which stretched appearance so far beyond being.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 58,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "By a supreme effort she held back her tears, but it was years before she forgot the picture of her mother sitting back in the old Morris chair, composing herself for death.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 62,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Of course she was being unconscionably idle; but as her days were filled to overflowing with the impact of new impressions, this signified nothing.",
    author: "Jessie Fauset",
    title: "Plum Bun: A Novel Without a Moral",
    pages: 91,
    originalPublicationDate: 1929,
    originalPublisher: "Frederick A. Stokes",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "Gradually she began to comprehend, and she stood motionless, listening, her pale lips firmly compressed, her eyes only showing her agitation and how grieved she was; their dark-blue was almost black, and they glowed like stars.",
    author: "Maria Amparo Ruiz de Burton",
    title: "The Squatter and the Don",
    pages: 269,
    originalPublicationDate: 1885,
    originalPublisher: "C. Loyal",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "She seems absorbed, silent, thoughtful, sad, and--and--you know what I fear. She says she is not sick, then it is some mental trouble, I am sure.",
    author: "Maria Amparo Ruiz de Burton",
    title: "The Squatter and the Don",
    pages: 95,
    originalPublicationDate: 1885,
    originalPublisher: "C. Loyal",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "In my opinion, no kind-hearted girl ought to desire to be loved except by the one she loves.",
    author: "Maria Amparo Ruiz de Burton",
    title: "The Squatter and the Don",
    pages: 208,
    originalPublicationDate: 1885,
    originalPublisher: "C. Loyal",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "[T]he unhappy girl pressed her hands to her forehead, as if to keep together her distracted thoughts.",
    author: "Maria Amparo Ruiz de Burton",
    title: "The Squatter and the Don",
    pages: 276,
    originalPublicationDate: 1885,
    originalPublisher: "C. Loyal",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
  {
    quote:
      "The fainting girl was tenderly placed in her bed, and all the care that loving hearts could bestow was lavished on her.",
    author: "Maria Amparo Ruiz de Burton",
    title: "The Squatter and the Don",
    pages: 299,
    originalPublicationDate: 1885,
    originalPublisher: "C. Loyal",
    publisher: "",
    currentCutation: "",
    pseudonym: "",
  },
];
